module.exports = __webpack_public_path__ + "static/media/conference.cf950f60.jpg";